import React from "react";
import TeamCarousel from "./TeamCarousel";
import LucideIcon from "utils/LucideIcon";
import { motion } from "framer-motion";

const SectionOurCulture: React.FC = () => {
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut" as const,
      },
    },
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  return (
    <motion.div
      className="w-full py-20 px-4 text-center md:text-left"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={containerVariants}
    >
      <div className="mb-20">
        <div>
          <motion.h2
            variants={itemVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
          >
            <div className="flex items-center md:text-left justify-center md:justify-start mb-4">
              {/* <HeartHandshake className="w-10 h-10 text-blue-900 mr-3 hidden md:inline-block" /> */}
              <LucideIcon
                name="HeartHandshake"
                className="w-10 h-10 text-blue-900 hover:text-blue-900 hidden md:inline-block mr-3"
              />
              <h2 className="text-4xl md:text-5xl font-bold font-inter text-secondary-gradient bg-clip-text text-transparent">
                Life At 360Customizer
              </h2>
            </div>
          </motion.h2>
          <motion.div
            className="w-24 h-1 bg-secondary-gradient mx-auto md:mx-0 md:ml-14 mb-8 rounded-xl"
            initial={{ width: 0 }}
            whileInView={{ width: 96 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            viewport={{ amount: 0.2 }}
          ></motion.div>
        </div>
        <div>
          <motion.p
            className="text-xl text-gray-600 max-w-3xl leading-relaxed font-inter"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            Culture. Collaboration. Celebration. That’s Life at 360Customizer.
          </motion.p>
        </div>
      </div>
      <TeamCarousel />
    </motion.div>
  );
};

export default SectionOurCulture;
